import React from "react";
import Select from "react-select";
import {FontAwesomeIconProvider} from "../../providers/icons/fontAwesomeIconProvider";

export class SelectWithIcon extends React.Component {
    constructor(props) {
        super(props);

        this.state ={
            value: this.props.value
        }

        this.reset = this.reset.bind(this);
    }

    onChange = (e) => {
        this.props.onChange(e);
       this.setState({ value : e.id });
    }

    reset(){
        this.setState({ value : '' });
    }

    render() {
        const options = FontAwesomeIconProvider.getFontAwesomeIconData();
        let selectedItem;
        if (this.state.value){
            selectedItem = FontAwesomeIconProvider.getFontAwesomeIconItem(this.state.value)
        }

        if (selectedItem){
            return (
                <Select
                    value={selectedItem}
                    options={options}
                    placeholder="Selecciona una opción"
                    isDisabled={this.props.disabled}
                    onChange={this.onChange}
                />
            );
        } else {
            return (
                <Select
                    value={'Selecciona una opción'}
                    options={options}
                    placeholder="Selecciona una opción"
                    isDisabled={this.props.disabled}
                    onChange={this.onChange}
                />
            );
        }
    }
}